import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Cookie consent bar: essential vs all optional cookies.
 * Does not block strictly necessary session cookies (handled server-side).
 */
const CookieConsentBanner = ({
  visible,
  onAcceptAll,
  onAcceptEssentialOnly,
  onClose,
  isFirstVisit,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[100] px-3 pb-3 pt-0 sm:px-4 sm:pb-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="mx-auto max-w-5xl rounded-t-lg border border-gray-200 bg-white/95 text-gray-700 shadow-lg backdrop-blur-sm sm:rounded-lg">
        <div className="flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:p-5">
          <div className="min-w-0 flex-1 text-left text-sm leading-relaxed">
            <h2
              id="cookie-consent-title"
              className="mb-2 text-base font-semibold text-gray-900"
            >
              Cookies &amp; privacy
            </h2>
            <p id="cookie-consent-desc" className="text-gray-600">
              We use cookies and similar technologies to run the site (for example, to keep you
              signed in) and, with your permission, to understand how the site is used and to
              improve it. See our{' '}
              <Link
                to="/privacy-policy"
                className="font-medium text-gray-900 underline decoration-gray-400/70 underline-offset-2 hover:text-gray-700"
              >
                Privacy Policy
              </Link>{' '}
              for details.
            </p>
          </div>
          <div className="flex flex-shrink-0 flex-col gap-2 sm:w-auto sm:flex-row sm:flex-wrap sm:justify-end">
            <button
              type="button"
              onClick={onAcceptEssentialOnly}
              className="order-2 rounded-md border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 transition hover:bg-gray-50 sm:order-1"
            >
              Essential only
            </button>
            <button
              type="button"
              onClick={onAcceptAll}
              className="order-1 rounded-md bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-gray-800 sm:order-2"
            >
              Accept all
            </button>
            {!isFirstVisit && (
              <button
                type="button"
                onClick={onClose}
                className="order-3 w-full rounded-md px-2 py-1.5 text-xs text-gray-500 underline hover:text-gray-700 sm:w-auto sm:self-center"
              >
                Close without changing
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
